<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        :items="breadcrumb"
        @return="previousStep"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb :items="breadcrumb" @return="previousStep" />
    </template>
    <v-form ref="form">
      <v-row>
        <v-col cols="12">
          <p class="primary--text form__title mb-5">
            SEUS DADOS
          </p>
        </v-col>
      </v-row>
      <v-row class="pb-8">
        <v-col cols="12" md="2" class="d-flex align-center mb-5">
          <label for="upload-avatar">
            <img
              :src="avatarPicture"
              alt="Foto de perfil"
              width="120"
              height="120"
              class="me__photo rounded-circle"
            />
            <input
              type="file"
              id="upload-avatar"
              style="display: none"
              accept="image/png, image/jpeg"
              @change="uploadNewAvatar"
            />
          </label>
        </v-col>
        <v-col cols="12" md="9">
          <v-row>
            <v-col cols="12" md="8">
              <BaseFormInput
                id-element="meName"
                placeholder="Inserir"
                v-model="profile.nickname"
                validate-on-blur
                required
                :rules="[requiredInput]"
                label-text="Nome de Usuário"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <BaseFormInput
                id-element="mePhone"
                placeholder="Inserir"
                v-model="profile.telefone"
                validate-on-blur
                required
                :rules="[requiredInput, isValidPhoneNumber]"
                v-facade="maskPhone"
                label-text="Telefone"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="pt-4">
          <v-divider />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <p class="primary--text form__title mb-5">
            ALTERAR SENHA
          </p>
        </v-col>
      </v-row>
      <v-row class="me__password-wrapper align-center px-5 py-4 pb-md-0">
        <v-col cols="12" md="4" class="mr-md-5">
          <BaseFormInput
            id-element="meCurrentPassword"
            placeholder="Inserir"
            type="password"
            required
            :rules="[requiredInput]"
            label-text="Senha atual"
            :upper-case="false"
            v-model="password.senha_atual"
          />
        </v-col>
        <v-col cols="12" md="4" class="mr-md-5">
          <BaseFormInput
            id-element="meNewPassword"
            placeholder="Inserir"
            type="password"
            required
            :rules="[requiredInput, passwordRules]"
            label-text="Nova senha"
            :upper-case="false"
            v-model="password.nova_senha"
          />
        </v-col>
        <v-col cols="12" md="3">
          <BaseButton
            v-html="'TROCAR SENHA'"
            class="secondary font-weight-bold me__password-btn"
            width="100%"
            @click="submitNewPassword"
            :disabled="!(password.senha_atual && password.nova_senha)"
          />
        </v-col>
      </v-row>
      <BaseFooter>
        <v-row>
          <v-spacer />
          <v-col cols="12" sm="3">
            <BaseButton
              v-html="'SALVAR'"
              class="secondary font-weight-bold"
              width="100%"
              @click="submit"
            />
          </v-col>
        </v-row>
      </BaseFooter>
    </v-form>
  </Main>
</template>

<script>
import {
  requiredInput,
  isValidPhoneNumber,
  passwordRules
} from "@/utils/rules.js";
import { maskPhone } from "@/utils/masks.js";
import { mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import _ from "lodash";

export default {
  name: "MeInfo",
  mixins: [LoadingRequest],
  computed: {
    avatarPicture() {
      return this.profile?.avatar?.url || require("@/assets/blank_profile.svg");
    }
  },
  data: () => ({
    requiredInput,
    passwordRules,
    isValidPhoneNumber,
    maskPhone,
    password: {
      senha_atual: "",
      nova_senha: ""
    },
    profile: {},
    breadcrumb: [
      {
        to: "quotation",
        text: "Perfil"
      }
    ]
  }),
  methods: {
    ...mapActions("me", [
      "requestMyInfo",
      "saveMyInfo",
      "uploadAvatar",
      "changePassword"
    ]),
    async fetchData() {
      const data = await this.withLoading(this.requestMyInfo());
      this.profile = _.cloneDeep(data);
    },
    async uploadNewAvatar(event) {
      const file = event.target.files[0];
      const { nome, url } = await this.withLoading(
        this.uploadAvatar(this.getUploadFilePayload(file))
      );
      this.profile.avatar = { nome, url };
    },
    submit() {
      this.withLoading(this.saveMyInfo(this.profile)).then(() => {
        this.fetchData();
        this.showAlertNotification({
          message: `Informações salvas com sucesso.`,
          type: "success"
        });
      });
    },
    submitNewPassword() {
      if (this.$refs.form.validate())
        this.withLoading(this.changePassword(this.password)).then(() => {
          this.showAlertNotification({
            message: `Senha alterada com sucesso.`,
            type: "success"
          });
        });
    },
    previousStep() {
      this.$router.go(-1);
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>

<style lang="sass" scoped>
.me
  &__photo
    object-fit: cover
    cursor: pointer
  &__password-wrapper
    box-sizing: border-box
    border: 1px solid #D5D5E0
    border-radius: 2px
    background-color: #F0F0F7
  &__password-btn
    margin-top: 5px
</style>
